module.exports = __webpack_public_path__ + "img/THQ_Screen_1.0e8d3afa.jpg";